import React from 'react';
import { ImageInput } from '../../../presentational/contract/signing/image-input';
import { DrawingInput } from '../../../presentational/contract/signing/drawing-input';
import { TextInput } from '../../../presentational/contract/signing/text-input';
import { DateInput } from '../../../presentational/contract/signing/date-input';
import {AttachmentTypes} from "../../../../utils/constants/contract";
import {SignatureInput} from "../../../presentational/contract/signing/signature-input";
import {InitialsInput} from "../../../presentational/contract/signing/initials-input";

export const PdfAttachments = ({
  attachments,
  pdfName,
  pageDimensions,
  removeAttachment,
  updateAttachment,
  onHandleSignatureModal
}) => {
  const handleAttachmentUpdate = (index) => (attachment) => updateAttachment(index, attachment);

  return attachments ? (
    <>
      {attachments.length
        ? attachments.map((attachment, index) => {
            const key = `${pdfName}-${index}`;

            if (attachment.type === AttachmentTypes.IMAGE) {
              return (
                <ImageInput
                  key={key}
                  pageWidth={pageDimensions.width}
                  pageHeight={pageDimensions.height}
                  removeImage={() => removeAttachment(index)}
                  updateImageAttachment={handleAttachmentUpdate(index)}
                  {...(attachment)}
                />
              );
            }

            if (attachment.type === AttachmentTypes.DRAWING) {
              return (
                <DrawingInput
                  key={key}
                  pageWidth={pageDimensions.width}
                  pageHeight={pageDimensions.height}
                  removeDrawing={() => removeAttachment(index)}
                  updateDrawingAttachment={handleAttachmentUpdate(index)}
                  {...(attachment)}
                />
              );
            }

            if (attachment.type === AttachmentTypes.DATE) {
              return (
                <DateInput
                  key={key}
                  pageWidth={pageDimensions.width}
                  pageHeight={pageDimensions.height}
                  updateTextAttachment={handleAttachmentUpdate(index)}
                  {...(attachment)}
                />
              );
            }

            if (attachment.type === AttachmentTypes.TEXT) {
              return (
                  <TextInput
                      key={key}
                      isEditable={attachment.isEditable}
                      pageWidth={pageDimensions.width}
                      pageHeight={pageDimensions.height}
                      removeAttachment={()=>removeAttachment(index)}
                      updateTextAttachment={handleAttachmentUpdate(index)}
                      {...(attachment)}
                  />
              );
            }

            if (attachment.type === AttachmentTypes.SIGNATURE) {
              return (
                  <SignatureInput
                      key={key}
                      isEditable={attachment.isEditable}
                      pageWidth={pageDimensions.width}
                      pageHeight={pageDimensions.height}
                      removeAttachment={()=>removeAttachment(index)}
                      updateTextAttachment={handleAttachmentUpdate(index)}
                      onHandleSignatureModal={()=>onHandleSignatureModal(attachment?.editId,attachment?.signerId,index,true)}
                      {...(attachment)}
                  />
              );
            }

            if (attachment.type === AttachmentTypes.INITIALS) {
              return (
                  <InitialsInput
                      key={key}
                      isEditable={attachment.isEditable}
                      pageWidth={pageDimensions.width}
                      pageHeight={pageDimensions.height}
                      removeAttachment={()=>removeAttachment(index)}
                      updateTextAttachment={handleAttachmentUpdate(index)}
                      onHandleSignatureModal={()=>onHandleSignatureModal(attachment?.editId,attachment?.signerId,index,false)}
                      {...(attachment)}
                  />
              );
            }
            return null;
          })
        : null}
    </>
  ) : null;
};
